import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnChanges, OnDestroy, inject, input } from '@angular/core';
import { Observable, Subject, combineLatest, map } from 'rxjs';

import { whenTruthy } from 'ish-core/utils/operators';

import { DotCmsUveFacade } from '../../../facades/dot-cms-uve.facade';
import { VideoContentlet } from '../../../models/dot-cms-uve-contentlet.model';
import { DotCmsCodecEncodePipe } from '../../../pipes/dot-cms-codec-encode.pipe';
import { DotCmsUveBannerLinkComponent } from '../../dot-cms-uve-banner/dot-cms-uve-banner-link/dot-cms-uve-banner-link.component';

@Component({
  selector: 'custom-dot-cms-uve-banner-video',
  templateUrl: './dot-cms-uve-banner-video.component.html',
  styleUrls: ['./dot-cms-uve-banner-video.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, AsyncPipe, DotCmsCodecEncodePipe, DotCmsUveBannerLinkComponent],
})
export class DotCmsUveBannerVideoComponent implements OnDestroy, OnChanges {
  contentlet = input.required<VideoContentlet>();
  private destroy$ = new Subject<void>();
  triggerCount = 1;
  private dotCmsUveFacade = inject(DotCmsUveFacade);
  ngOnChanges(): void {
    // this.intersectionObserver = setupIntersectionObserver(this.elementRef.nativeElement, this.animationTriggered$);
    // this.contentlet$.pipe(takeUntil(this.destroy$)).subscribe(contentlet => {
    //   this.gtmFacade.setupIntersectionObserverForGTMEvent(
    //     this.elementRef.nativeElement,
    //     [contentlet],
    //     this.triggerCount,
    //     'view_promotion'
    //   );
    // });
  }

  buildVideoSrc(): Observable<string | null> {
    return combineLatest([this.dotCmsUveFacade.getDotCmsHost$.pipe(whenTruthy())]).pipe(
      whenTruthy(),
      map(([host]) => {
        const content = this.contentlet() as unknown as Record<string, any>;

        // Case 1: asset present
        if (content?.asset?.idPath) {
          return `${host}${content.asset.idPath}`;
        }

        // Case 2: fileAsset present (object or string)
        const fileAsset = content?.fileAsset;

        if (fileAsset && typeof fileAsset === 'object' && fileAsset.idPath) {
          return `${host}${fileAsset.idPath}`;
        }

        if (typeof fileAsset === 'string' && fileAsset) {
          let normalized = fileAsset;

          // Normalize /data/shared/assets → /dA
          if (normalized.startsWith('/data/shared/assets')) {
            normalized = normalized.replace('/data/shared/assets', '/dA');
          }
          normalized = normalized.replace(/^\/dA\/[^/]+\/[^/]+\//, '/dA/');

          // Encode filename part
          const lastSlash = normalized.lastIndexOf('/');
          const base = normalized.substring(0, lastSlash + 1);
          const fileName = normalized.substring(lastSlash + 1);
          const encodedFileName = encodeURIComponent(fileName);

          return `${host}${base}${encodedFileName}`;
        }

        return null;
      })
    );
  }

  bannerVideoWidth(contentlet: VideoContentlet): string {
    if (contentlet?.maxWidth) {
      return 'full-width-video';
    }
    return;
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
